import { useState } from 'react'
import { MessageSquare, ChevronUp, ChevronDown } from 'lucide-react'
import Comment from './Comment'

const COMMENTS_SHOW_BY_DEFAULT = 3

const Comments = ({ comments, platform }) => {
    const [show, setShow] = useState(comments.slice(0, COMMENTS_SHOW_BY_DEFAULT))
    const [shown, setShown] = useState(false)

    const toggle = () => {
        if (shown) {
            setShow(comments.slice(0, COMMENTS_SHOW_BY_DEFAULT))
            setShown(false)
        } else {
            setShow(comments)
            setShown(true)
        }
    }

    return (
        <div className="tw:pt-3 tw:-mb-5">
            <div className="tw:flex tw:items-center tw:gap-2 tw:text-gray-300 tw:mb-4">
                <MessageSquare size={20} />
                <span className="tw:text-sm tw:hidden sm:tw:block">{comments.length} Comments</span>
                {comments.length > COMMENTS_SHOW_BY_DEFAULT && (
                    <button
                        onClick={toggle}
                        className="tw:text-gray-400 tw:hover:text-white tw:transition-colors"
                        aria-label={shown ? 'Show fewer comments' : 'Show all comments'}
                    >
                        {shown ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                    </button>
                )}
            </div>
            <ul className="tw:space-y-4 tw:list-none tw:m-0 tw:p-0">
                {show.map((comment) => (
                    <li key={comment.id}>
                        <Comment comment={comment} platform={platform} />
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default Comments
